import { Component, OnDestroy, OnInit } from '@angular/core';
import { TemplateService } from '../../../web-generator/template-generator/service/template.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-not-found-proxy',
  templateUrl: './not-found-proxy.component.html',
  styleUrls: ['./not-found-proxy.component.scss']
})
export class NotFoundProxyComponent implements OnInit, OnDestroy {
  protected _subcs: Subscription[] = [];
  /** 使用的版本號 */  
  useVersionNo: string;

  constructor(
    protected templateService: TemplateService,
  ) { }

  ngOnInit() {
    const subc = this.templateService.siteInfo$.subscribe(info => {
      if (info) {
        if (info.template.selector === 'template-040') {
          this.useVersionNo = '1';
        } else {
          this.useVersionNo = '2';
        }
      }
    });
    this._subcs.push(subc);
  }

  ngOnDestroy(): void {
    while (this._subcs.length) {
      this._subcs.pop().unsubscribe();
    }
  }
}